import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Btn, CustomCheckbox, CustomDataTableHeader, Loading } from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import {
  desassociarSobraOrdemColeta,
  getSobrasAssociadas,
} from '../../../../services/api/https/ordem-coleta/ordem-coleta.http'
import { renderOrdemColetaQuantityCell } from '../ordem-coleta-volume-and-units.helper'

function SobraAssociada({ tpId, companyId, ordemColetaId, dispatch }) {
  // Vars

  // Hooks
  const [isLoading, setIsLoading] = useState(true)
  const [btnDesassociarIsLoading, setBtnDesassociarIsLoading] = useState(false)
  const [sobras, setSobras] = useState([])
  const [globalFilter, setGlobalFilter] = useState('')

  useEffect(() => {
    getSobras()
  }, [])

  // Events
  const onItemClicked = (sobra, checked) => {
    const index = sobras.findIndex(s => s.leftover_product_id === sobra.leftover_product_id)
    if (index !== -1) {
      const nSobras = [...sobras]
      nSobras[index].selected = checked
      setSobras(nSobras)
    }
  }

  const onBtnDesassociarClick = async () => {
    try {
      setBtnDesassociarIsLoading(true)
      const sobrasSelecionadas = sobras.filter(s => s.selected)
      if (sobrasSelecionadas.length === 0) throw new Error('Selecione as Sobras para associação')
      const leftover_product_ids = sobrasSelecionadas.map(s => s.leftover_product_id)
      await desassociarSobraOrdemColeta(leftover_product_ids)
      await getSobras()
      dispatch(showMessageBox('Dessociação Realizada com Sucesso'))
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      setBtnDesassociarIsLoading(false)
    }
  }

  // Helpers
  const getSobras = async () => {
    try {
      const fetchedSobras = await getSobrasAssociadas(ordemColetaId)
      setSobras(fetchedSobras)
      setIsLoading(false)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  // Render
  return isLoading ? (
    <div className="text-center">
      <Loading />
    </div>
  ) : (
    <div>
      <div style={{ marginBottom: 15, marginTop: 10 }}>
        <Btn isLoading={btnDesassociarIsLoading} onClick={onBtnDesassociarClick}>
          Desassociar
        </Btn>
      </div>
      <DataTable
        paginator={true}
        rows={5}
        value={sobras}
        header={<CustomDataTableHeader onChange={setGlobalFilter} />}
        globalFilter={globalFilter}
        emptyMessage="Não existe Sobra Associada"
      >
        <Column
          header=""
          style={tableCellCentered(80)}
          body={sobra => (
            <CustomCheckbox
              checked={sobra.selected}
              onChange={value => onItemClicked(sobra, value)}
            />
          )}
        />
        <Column
          field="product_code"
          header="Código"
          style={{ textAlign: 'center', wordBreak: 'break-word', maxWidth: '150px' }}
        />
        <Column field="product_name" header="Produto" />
        <Column
          field="qte_original"
          header="Qte. Original"
          style={tableCellCentered(110)}
          body={sobra => renderOrdemColetaQuantityCell(sobra, sobra.qte_original)}
        />
        <Column
          field="qte_adjusted"
          header="Qte. Ajuste"
          style={tableCellCentered(110)}
          body={sobra => renderOrdemColetaQuantityCell(sobra, sobra.qte_adjusted || 0)}
        />
        <Column
          field="qte_sobras"
          header="Qte. Sobras"
          style={tableCellCentered(110)}
          body={sobra => renderOrdemColetaQuantityCell(sobra, sobra.qte_sobras)}
        />
        <Column field="picking" header="Picking" />
        <Column field="fleet_id" header="Rota" style={tableCellCentered()} />
        <Column field="driver_name" header="Motorista" />
      </DataTable>
    </div>
  )
}

export default connect()(SobraAssociada)
